define(
    'modules/recent-products',[
        'jquery',

        'utils/local-storage',
        'utils/debounce'
    ],

    function ($, localStorage, debounce) {
        function RecentProducts (recentProductsView) {
            this.$view = recentProductsView;
            this.$list = recentProductsView.find('.recent-products__list');
            this.$clearBtn = recentProductsView.find('.recent-products__clear-btn');
        }

        RecentProducts.prototype.numberOfProducts = 8;
        RecentProducts.prototype.hasDragListener = false;

        /**
         * Run all init methods
         *
         * @method init
         */
        RecentProducts.prototype.init = function () {
            var recentProducts = localStorage.get('recentproducts', true);
            if (!$.isArray(recentProducts) || recentProducts.length < 1) return;

            // Pick the 4 latest unique products visited.
            var links = recentProducts.map(function(obj) { return obj.link; });
            var recentDistinct = recentProducts.filter(function(product, i) { 
                return links.indexOf(product.link) === i;
            }).slice(0, this.numberOfProducts);
            
            // Save filtered list.
            localStorage.set('recentproducts', recentDistinct, true);

            this.initClear();
            this.initRemoveButtons();
            this.initItems(recentDistinct);
            this.$view.show();
            this.initDraggable();
        };

        RecentProducts.prototype.initDraggable = function() {
            var debounced = debounce(this.toggleVerticalScroll.bind(this), 500);
            this.toggleVerticalScroll();
            $(window).on('resize', debounced);
        };

        RecentProducts.prototype.hasScrollbar = function() {
            var list = this.$list.get(0);

            return list.scrollWidth > list.clientWidth;
        };

        RecentProducts.prototype.toggleVerticalScroll = function() {
            if (this.hasScrollbar() && !this.hasDragListener) {
                this.addVerticalScrollListener();
                this.addVerticalScrollButtonsListener();
                this.$list.add(this.$list.parent()).addClass('draggable');
            } else if (!this.hasScrollbar() && this.hasDragListener) {
                this.removeVerticalScrollListener();
                this.hideVerticalScrollButtons();
                this.$list.add(this.$list.parent()).removeClass('draggable');
            }
        };

        RecentProducts.prototype.removeVerticalScrollListener = function() {
            this.$view.off();
            $(document).off('mouseup.recentListGrabbed');
            this.hasDragListener = false;
        };

        RecentProducts.prototype.addVerticalScrollListener = function() {
            var clicked = false, clickX;
            var _this = this;

            this.$view.on({
                'mousemove': function(e) {
                    if (clicked) updateScrollPos(e, _this.$list);
                },
                'mousedown': function(e) {
                    e.preventDefault();
                    clicked = true;
                    clickX = e.pageX;
                    $(this).addClass('grabbing');
                }
            });

            $(document).on('mouseup.recentListGrabbed', function() {
                clicked = false;
                _this.$view.removeClass('grabbing');
            });

            var updateScrollPos = function(e, el) {
                el.scrollLeft(el.scrollLeft() + (clickX - e.pageX));
            };

            this.hasDragListener = true;
        };

        RecentProducts.prototype.addVerticalScrollButtonsListener = function() {
            var _this = this,
                rightBtn = this.$view.find('.scroll-right'),
                leftBtn = this.$view.find('.scroll-left'),
                scrollInterval = _this.$list.find('.recent-products__list-item').outerWidth();

            rightBtn.show();
            leftBtn.show();

            rightBtn.on('click', function() {
                _this.$list.animate({scrollLeft: "+=250px"}, "slow");
            });
            leftBtn.on('click', function() {
                _this.$list.animate({scrollLeft: "-=250px"}, "slow");
            });
        };

        RecentProducts.prototype.hideVerticalScrollButtons = function() {
            var rightBtn = this.$view.find('.scroll-right'),
                leftBtn = this.$view.find('.scroll-left');
                
            rightBtn.hide();
            leftBtn.hide();
        };

        /**
         * Bind clear storage and dom to button click.
         */
        RecentProducts.prototype.initClear = function() {
            var _this = this;

            this.$clearBtn.on('click', function () {
                localStorage.delete('recentproducts', true);
                _this.$list.empty();
                $(this).remove();
                _this.toggleVerticalScroll();
            });
        };

        RecentProducts.prototype.initRemoveButtons = function() {
            var _this = this;

            this.$list.on('click', '.recent-products__item-remove', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var $item = $(this).closest('li');
                var productLink = $item.find('a').attr('href');

                // Update sessionStorage
                var storedList = localStorage.get('recentproducts', true);
                var newList = storedList.filter(function(product) {
                    return product.link !== productLink;
                });
                localStorage.set('recentproducts', newList, true);

                $item.remove();
                _this.toggleVerticalScroll();
            });
        };

        /**
         * Add recent products to DOM.
         * @param  {Array} list  - the stored data from sessionStorage.
         */
        RecentProducts.prototype.initItems = function(list) {
            var _this = this;
            list.forEach(function (product) {
                _this.$list.append(_this.createListItem(product));
            });
        };

        /**
         * Create list element with product data.
         *
         * @param {Object} productData - An object containing data about a recently viewed product.
         * @return {jQuery Element} - list item element.
         */
        RecentProducts.prototype.createListItem = function (productData) {
            return $(
                '<li class="recent-products__list-item">' +
                    '<img class="recent-products__item-image" src="' + productData.img + '" />' +
                    '<a href="' + productData.link +'">' +  
                        '<div class="recent-products__item-info">' + productData.name + '</div>' +
                    '</a>' +
                    '<div class="recent-products__item-remove"><span class="icon-cancel"></span></div>' +
                '</li>'
            );
        };

        return RecentProducts;
    }
);
